export const fileUploadFields = [
    "Obfuscated Merchant ID",
    "Carrier ID",
    "Carrier Name",
    "Obfuscated Marketplace ID",
];